<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-modal" @close="close">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                             leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-semitone-modal-overlay transition-opacity"/>
            </TransitionChild>
            <div class="fixed z-modal inset-0 overflow-y-auto">
                <div class="flex xxs:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                                     enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                     enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                                     leave-from="opacity-100 translate-y-0 sm:scale-100"
                                     leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                                :class="[ styleClasses.dialogPanel.default, styleClasses.dialogPanel.background, styleClasses.dialogPanel.overflow, maxWidth ]">
                            <div class="block absolute top-0 right-0 pt-4 pr-4 z-sticky">
                                <button type="button" @click.prevent="$emit('close')">
                                    <span class="sr-only"> Close </span>
                                    <img v-if="colorMode === 'light'" src="@/assets/icons/close-dark.svg" alt="close"/>
                                    <img v-else src="@/assets/icons/close-white.svg" alt="close"/>
                                </button>
                            </div>
                            <slot/>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script setup>
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {computed, defineEmits, defineProps} from 'vue';

const props = defineProps({
    show: {
        type: Boolean,
        required: true,
        default: false,
    },
    overflowHidden: {
        type: Boolean,
        default: true,
    },
    ignoreClickOutside: {
        type: Boolean,
        default: true,
    },
    colorMode: {
        type: String,
        default: 'light',
    },
    maxWidth: {
        type: String,
        default: 'sm:max-w-lg',
    }
});
const emit = defineEmits(['update:show', 'close']);

const close = () => {
    if(props.ignoreClickOutside) return;
    emit('update:show', false);
};

const styleClasses = computed(() => ({
    dialogPanel: {
        default: 'relative rounded px-4 pt-5 pb-4 text-left shadow-xl transition-all xxs:w-full sm:w-full bottom-1/4 sm:bottom-1/2 box-border',
        background: {
            'bg-dark-1': props.colorMode === 'dark',
            'bg-white': props.colorMode === 'light',
        },
        overflow: {
            'overflow-hidden': props.overflowHidden,
            'overflow-visible': !props.overflowHidden,
        }
    }
}));
</script>
